import * as constants from './constants';

export const sessionExtension = (state = {
  isSessionExtended: true, error: false, timerToggleFlag: false, logOffTimerFlag: false,
}, action) => {
  switch (action.type) {
    case constants.SESSION_ASYNC_FETCH:
      return { ...state, isSessionExtended: false, error: false };

    case constants.SESSION_ASYNC_FETCH_SUCCESS:
      return { ...state, isSessionExtended: true, error: false };

    case constants.SESSION_ASYNC_FETCH_FAILURE:
      return { ...state, isSessionExtended: false, error: true };

      // SESSION_ALIVE_SUCCESS

    case constants.SESSION_ALIVE_SUCCESS: {
      const preState = state.timerToggleFlag;
      return { ...state, timerToggleFlag: !preState };
    }
    case constants.SESSION_LOGOFF_SUCCESS: {
      const preState = state.logOffTimerFlag;
      return { ...state, logOffTimerFlag: !preState };
    }


    default:
      return state;
  }
};
